var _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDynamic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666992,
    width: 59.333,
    height: 59.333,
    rx: 4,
    fill: "#01F0B6",
    fillOpacity: 0.07
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 8.33301,
    width: 42,
    height: 42,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_132_9107",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_132_9107",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADrElEQVR4nO2aP2gUURDGZ4JJQBTBQqKgiGAhaiGkEVNE1FI7wWBvY6EIYqWxjIqFjWAnYhVQJLl5mxg0IloIQWNhERAEMTEhZN8kOfF/nuwmiJiY3Dtfbmf35gfbHbPzfTf3dmb2ABRFURRFURRFUZRwoDURWhpDS2/QmmfI1I2WboClyxDTGeDoOMSmDaai3TD5cAu4zoaAt68jbNSObFzFl6UvyOYDMg2jpX60dBeYLmYtIxcg0xMvs/+6wJqzWWvIB7Z0sHqj6R0405y1hMJXNXDUkXXu9VDVr/Th6Ets2pDNjOfZfMj7PnVLTHvTls63mq0xWaeeD2ZKuxZ65rkqTP4J1uzLWoJsbLQdmW6hNT/+o9O4nbUMuUz1bU0mvoWBo+qeGS19hrhnW9Zy5FEutVRhsF2mmq9mLUkW3Lcx2Vcg07THkTCLTF0QD2xANo+X+EycxlUAYGJwHbC5sHxVLro+pYuk2f5Nvz2coQOL2zk6px470wxsTqE14x7dw9fkwQjlaPNSBiLT4B/VXuejthtqTA1mGvV4oH1Da+4Al3ZUMMTMVzObk1CXuM6GZFeMlt769L9J7wzTvTsrvc18VdNw/Y3aLjW4A60Z8ajgOWS6ly7vfbFROzAdgbqCo8PI9NJzuBgAptasU88H6VlJT/0GC/M82chlnXo+mI72I5tHnpPbC4jN0axTzwdMrelLU78j4jXE0TFwDrNOH1x3E7K5kr70/Xe+o+lw5Lqbap/gVO8eZLrvtVGzZgTYnJDUFSQGehRIl/CNGr1P+mdwg2tAGMtX8qJC+bj6GbmhRmRzHS199ziDx4DpdDY/ucrwO/KMq0FCdM3jm58EG52H0Z61IBx5RluaqOCIYGBzCSYfrIecgPKMXm4BROX0QZHDtSSKM3qpp3OyoE9WluVSC+QUlGZ00jGkZqd/MjTjaOlmEV4ToTijpeHCDBpqdI0GDTW6RoOGGr0CoQxSo1dAja4RqBWtRhcK1IpWo2XgZA0ahe06UNigUVyjraxBo7hGsyyD1GhWo7Wi8wAK+8nr0cFqtFb0qlLQQQOltXdFHTRQnNEFHTRQnNHChKGwOMGQJgyFxQmGNGEoLE4wpAlDYXGCIU0YCosTDGnCUFicYEgThsLiBEOaMBQWJxjShKGwOMGQJgyFxQmGNGEoLE4wpAlDYXGCIU0YCosTDGnCUFicYEgThsLiBEOaMBQWJxjShKGwOMGQJgyFxVEURVEURVEURVEURYE64BfzcL8vj/WNMgAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamic);
export default __webpack_public_path__ + "static/media/dynamic.31db7f3c0f53fd7948ab2c4bc0334d43.svg";
export { ForwardRef as ReactComponent };